
import {forkJoin as observableForkJoin,  Observable } from 'rxjs';
import { Component, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { NewsletterSubscribersService } from "app/newsletter/newsletter-subscribers/newsletter-subscribers.service";
import { NewsletterListResource } from "app/models/NewsletterListResource";
import { NewsletterResource } from "app/models/NewsletterResource";
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";
import { NotificationsService } from "angular2-notifications";
import { SubscribersImportErrorLinesResource } from "app/models/SubscribersImportErrorLinesResource"
import { TagResource } from 'app/models/TagResource';
import { TagListResource } from 'app/models/TagListResource';
import { FilterCriteriaListEdt } from 'app/models/FilterCriteriaListEdt';
import { FilterCriteriaEDT } from 'app/models/FilterCriteriaEDT';
import { UtilsService } from 'app/services/utils.service';

@Component({
  selector: 'vbn-newsletter-subscribers',
  providers: [NewsletterSubscribersService],
  templateUrl: './newsletter-subscribers.component.html',
  styleUrls: ['./newsletter-subscribers.component.scss']
})
export class NewsletterSubscribersComponent implements OnInit {

  newsletterListResource: NewsletterListResource;
  errorMessage: String;
  language: String = localStorage.getItem('vbn-language');
  cinema: any;
  news: any;
  showImportButton: boolean;
  showButton: boolean;
  newsSelected: any;
  cinemaSelected: any;
  files: any;
  formDataDoc: FormData;
  showImportedFile: boolean;
  importFile: SubscribersImportErrorLinesResource;
  showImportSection: boolean;
  showSubscribeTable: boolean;
  showMessage: boolean = false;
  subscriber: NewsletterResource;
  showEditSubscriber: boolean;
  showList: boolean;
  showConfirmation: boolean;
  subscriberListForDelete: NewsletterListResource;
  deleteAllSubscribers: boolean;
  subscriberToDelete: NewsletterResource;
  currentLanguage = localStorage.getItem("vbn-language");
  userEmail: string;

  // tagList={
  //   ro: [],
	//   fr: [],
	//   en: []
  // }
  // tagListResource={
  //   ro: [],
	//   fr: [],
	//   en: []
  // }
  // checkTags={
  //   ro:[],
  //   fr:[],
  //   rn:[]
  // }
  checked: boolean;
  checkObject: any;
  noneSelected: boolean = true;
  pageNumber: number;
  configPagination: any;
  numberOfItemsPerPage: number;
  filterFields=["email","active","external"];
  filter={
    email:  null,
    active: null,
    external: null
  }
  filterToSend: FilterCriteriaListEdt;
  filterItem: FilterCriteriaEDT;
  isOnResponsive:boolean=false;

  constructor(
    private translate: TranslateService,
    private _notificationService: NotificationsService,
    private newsletterSubscribersService: NewsletterSubscribersService,
    private service: UtilsService) {
    this.newsletterListResource = new NewsletterListResource()
    this.newsletterListResource.newsletterList = new Array();
    this.showSubscribeTable = false;
    this.showImportedFile = false;
    this.showImportSection = false;
    this.showButton = true;
    this.subscriber = new NewsletterResource();
    this.subscriber.tags = new Array();
    this.showEditSubscriber = false;
    this.showList = true;
    this.showConfirmation = false;
    this.subscriberListForDelete = new NewsletterListResource();
    this.subscriberListForDelete.newsletterList = new Array();
    this.deleteAllSubscribers = false;
    // this.tagListResource["ro"] = this.tagListResource["en"] = /* this.tagListResource["fr"] =  */ new Array<TagResource>();
    // this.tagList["ro"] = this.tagList["en"] = /* this.tagList["fr"] = */  new Array<TagResource>();
    // this.checkTags["ro"] = this.checkTags["en"] =/*  this.checkTags["fr"] =  */ new Array();;
    this.numberOfItemsPerPage = 15;
    this.pageNumber = 1;
    this.filter.active = undefined;
    this.filter.external = undefined;
    this.filterToSend = new FilterCriteriaListEdt();
    this.filterToSend.filters = [];
    
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLanguage = localStorage.getItem("vbn-language");
		});
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const innerWidth = window.innerWidth;
    if (innerWidth <= 1100) {
      this.isOnResponsive = true;
    }
    else {
      this.isOnResponsive = false;
    }
  }

  ngOnInit() {
    this.userEmail = this.service.currentUserEmail;
    this.getAllSubscribers();
    if (innerWidth <= 1100) {
      this.isOnResponsive = true;
    }
    else {
      this.isOnResponsive = false;
    }
    //this.getAllActiveTags("ro");
    //this.getAllActiveTags("fr");
    //this.getAllActiveTags("en");
    //this.getAllActiveTags("de");
  }
  // @Output() sendSubscriber = new EventEmitter<NewsletterResource>()

  // getAllActiveTags(language) {
	// 	this.newsletterSubscribersService.getAllTags('/admin/tags/getAllActive?language=' + language)
	// 		.subscribe(
	// 			response => {
	// 				// Object.assign(this.tagListResourceRO, response);
  //         this.tagList[language] = response.tagListResource;
  //         if (this.tagList[language] == null) {
  //           this.tagListResource[language] = []
  //         } else {
  //           this.tagListResource[language] = this.tagList[language];
  //         }
  //         this.checkTags[language] = new Array();
  //         for (let i = 0; i < this.tagListResource[language].length; i++) {
  //           this.checkObject = {};
  //           this.checkObject.check = false;
  //           this.checkObject.rid = this.tagListResource[language][i].rid;
  //           this.checkTags[language].push(this.checkObject)
  //         }
  //         this.checkObject = {};
	// 			},
	// 			error => this.errorMessage = <any>error
	// 		);
  // }
  
  editSubscriber(subs: NewsletterResource) {
    this.subscriber = subs;
    this.showEditSubscriber = true;
    this.showList = false;
  }

  closeEditSubscriber(event) {
    this.showEditSubscriber = false;
    this.showList = true;
    this.getAllSubscribers();
  }
  showModal() {
    this.deleteAllSubscribers = true;
  }

  getAllSubscribers() {
    this.showMessage = false;
    this.newsletterSubscribersService.getAllSubscribers(`/admin/newsletter/getAll?pageNumber=${this.pageNumber}&numberOfItemsPerPage=${this.numberOfItemsPerPage}&userEmail=${this.userEmail}`, this.filterToSend)   // ------ new request
      .subscribe(
      response => {
        this.newsletterListResource = response;
        if (response.errorCode == 7000) {
          this.showSubscribeTable = false;
          this.showMessage = true;
        }
        if (this.newsletterListResource.newsletterList != null && this.newsletterListResource.newsletterList != undefined) {
          if (this.newsletterListResource.newsletterList.length > 0) {
            this.showSubscribeTable = true;
          }
        }
        this.configPagination = {
          cap: response.numberOfPages,
          start: this.pageNumber
        }
        console.log("Newsletter list subscribers: ", response)


      },
      error => this.errorMessage = <any>error);
  }

  switchStatusSubscriber(subscriber){
   this.newsletterSubscribersService.switchStatus(`admin/newsletter/switchStatus/` + subscriber.rid)
      .subscribe(
      response => {
       this.getAllSubscribers();
      },
      error => this.errorMessage = <any>error);
  }

  getExportFile() {
    let lang  = this.currentLanguage;
   // let tagListForExport = new TagListResource();
    //tagListForExport.tagListResource = new Array();
    // if(this.subscriber !== null && this.subscriber !== undefined && this.subscriber.tags != null && this.subscriber.tags.length !== 0){
    //   Object.assign(tagListForExport.tagListResource, this.subscriber.tags);
    // }else{
    //   Object.assign(tagListForExport.tagListResource, this.tagListResource[lang]);
    // }
    this.newsletterSubscribersService.getExportFile(`/admin/newsletter/exportFileByFilters?language=` + this.currentLanguage + "&userEmail="+this.userEmail, null)
      .subscribe(
      response => {
        window.location.href = `admin/newsletter/exportFile?file=` + response;
        // this.cinemaSelected = false;
        this.newsSelected = false;
      },
      error => {
        
        this.errorMessage = <any>error;
      });
  }

  changeListenerDOC($event): void {
    this.files = $event.target.files;
    console.log("------------------fisier de import", this.files)
  }

  saveDocuments() {
    let errorFiles: string[] = []
    for (let i = 0; i < this.files.length; i++) {
      this.formDataDoc = new FormData()
      var fileDoc: File = this.files[i];
      this.formDataDoc.append('file', fileDoc, fileDoc.name)
      this.newsletterSubscribersService.upload(`/admin/newsletter/uploadFiles?userEmail=${this.userEmail}`, this.formDataDoc)
        .subscribe(
        response => {
          console.log(response);
          this.importFile = response;
          console.log("----------------------", this.importFile)
          this.showImportedFile = true;
          this.showImportSection = false;
          this.files = [];
          this.showButton = true;
          this.getAllSubscribers();
          if (this.importFile.errorLines.length == 0) {
            observableForkJoin(
              this.translate.get('Success'),
              this.translate.get('File was successfully imported!')
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'success')
            })
            return
          }
        },
        error => {
          if (error.errorCode == 105) {
            observableForkJoin(
              this.translate.get('Error'),
              this.translate.get('Only .xls and .xlsx files are supported!')
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            })
            return
          }
        })
    }
  }

  showImport() {
    this.showImportSection = true;
    this.showImportButton = false;
    this.showButton = false;
  }

  cancel() {
    this.showImportButton = true;
    this.showImportSection = false;
    this.showButton = true;
  }

  setSubscriberToDelete(subscriber: NewsletterResource) {
    this.subscriberToDelete = null;
    this.subscriberToDelete = subscriber;
  }

  deleteSubscriber() {
    let url = "admin/newsletter/delete?email=" + this.subscriberToDelete.email+"&userEmail="+this.userEmail
    this.newsletterSubscribersService.deleteSubscribers(url)
      .subscribe(
      response => {
        observableForkJoin(
          this.translate.get('Success'),
          this.translate.get(' The subscriber has been successfully deleted!')
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'success')
        })
        this.getAllSubscribers();
        this.showConfirmation = false;
      },
      error => this.errorMessage = <any>error
      );
  }

  checkSubscriber(subscriber: NewsletterResource) {
    for (let i = 0; i < this.subscriberListForDelete.newsletterList.length; i++) {
      if (subscriber.rid == this.subscriberListForDelete.newsletterList[i].rid) {
        return true;
      }
    }
    return false;
  }
  updateCheckedOptions(subscriber: NewsletterResource, event) {
    if (event.target.checked) {
      this.subscriberListForDelete.newsletterList.push(subscriber);
    } else {
      let index = this.subscriberListForDelete.newsletterList.indexOf(subscriber);
      this.subscriberListForDelete.newsletterList.splice(index, 1);
    }

  }
  
  checkAll() {
    this.subscriberListForDelete.newsletterList = Object.assign([], this.newsletterListResource.newsletterList);
  }

  uncheckAll() {
    this.subscriberListForDelete.newsletterList = [];
  }

  deleteAll() {
    this.newsletterSubscribersService.multipleDeleteSubscribers(`/admin/newsletter/delete/newsletterList`, this.subscriberListForDelete)
      .subscribe(
      body => {
        this.subscriberListForDelete.newsletterList = [];
        this.getAllSubscribers();
        this.deleteAllSubscribers = false;
      },

      error => console.error(error))
  }

  // checkAllTags() {
  //   let lang = this.currentLanguage;
	// 	this.checked = true;
	// 	this.subscriber.tags = new Array();
	// 	for (let i = 0; i < this.checkTags[lang].length; i++) {
	// 		this.checkTags[lang][i].check = true;
  //     let tag = new TagResource();
  //     tag.rid = this.checkTags[lang][i].rid;
  //     this.subscriber.tags.push(tag);
	// 	}
	// 	this.noneSelected = false;
	// }
  // uncheckAllTags() {
  //   let lang = this.currentLanguage;
	// 	this.checked = false;
	// 	for (let i = 0; i < this.checkTags[lang].length; i++) {
	// 		this.checkTags[lang][i].check = false;
	// 	}
	// 	this.subscriber.tags = new Array();
	// 	this.noneSelected = true;
	// }

  // updateCheckedOptionsTags(tags: TagResource, event) {
  //   let lang = this.currentLanguage;
  //   if (!event.target.checked){
  //     for (let i = 0; i < this.subscriber.tags.length; i++) {
  //       if (tags.rid == this.subscriber.tags[i].rid) {
  //         this.subscriber.tags.splice(i, 1);
  //         return
  //       }
  //     }
  //   }
  //   else{
  //     this.subscriber.tags.push(tags);
  //   }
	// 	console.log("subscriber.tags", this.subscriber.tags);
  //   }
    
    handlePageChange(event) {
      this.pageNumber = event
      this.getAllSubscribers();
    }
    
    applyFilter(){
      this.filterToSend = new FilterCriteriaListEdt();
      this.filterToSend.filters = [];

      let filterItem;
      for( let field of this.filterFields){
        filterItem = new FilterCriteriaEDT();
        if( this.filter[field] !== null &&  this.filter[field] !== undefined){
          filterItem.field = field;
          filterItem.value = this.filter[field];
          filterItem.type = (field === "email") ? "string" : "boolean";
          this.filterToSend.filters.push(filterItem);
        }
      }
      this.getAllSubscribers();
    }

    resetFilter(){
      this.filterToSend = new FilterCriteriaListEdt();
      this.filter={
        email:  null,
        active: null,
        external: null
      }
      this.getAllSubscribers();
    }

    showResponsiveDetails(id) {
      const width = window.innerWidth;
      if (width <= 1100) {
        for (let i = 0; i < this.newsletterListResource.newsletterList.length; i++) {
          if (this.newsletterListResource.newsletterList[i].rid == id) {
            this.newsletterListResource.newsletterList[i].showDetailsOnResponsive = !this.newsletterListResource.newsletterList[i].showDetailsOnResponsive;
          }
          else {
            this.newsletterListResource.newsletterList[i].showDetailsOnResponsive = false;
          }
        }
      }
      else {
        return;
      }
  
    }
}
